(() => {
  'use strict';
  const config = document.querySelector('script[data-sender-google-widget]');
  const merchantId = config && config.dataset.merchantId;
  if (!merchantId || !/^\d+$/.test(merchantId)) return;
  let requested = false;

  const allowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
  };
  const loadWidget = () => {
    if (requested || !allowed() || document.querySelector('#merchantWidgetScript')) return;
    requested = true;
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.defer = true;
    script.addEventListener('load', () => {
      if (!allowed() || !window.merchantwidget) return;
      window.merchantwidget.start({
        merchant_id: Number(merchantId),
        position: 'LEFT_BOTTOM',
        sideMargin: 16,
        bottomMargin: 32,
        mobileSideMargin: 16,
        mobileBottomMargin: 150
      });
    }, { once: true });
    document.head.appendChild(script);
  };
  document.addEventListener('visitorConsentCollected', loadWidget);
  if (window.Shopify && window.Shopify.customerPrivacy) {
    loadWidget();
  } else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) loadWidget();
    });
  }
})();
